import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTracking } from 'react-tracking';

import './FormSiteEmbed.css';
import Modal from 'react-bootstrap/Modal';

export default function FormSiteModal({
  toggle, embedParams, isShowing, updateAssigned, messageId,
}) {
  const { trackEvent } = useTracking();

  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute(
      'src',
      'https://fs9.formsite.com/include/form/embedManager.js',
    );
    script.setAttribute(
      'id',
      'formsite-script',
    );
    script.addEventListener('load', () => {
      // eslint-disable-next-line no-undef
      EmbedManager.embed({
        key: embedParams.key,
        prePopulate: embedParams.prePopulate,
        width: '100%',
      });
    });
    document.body.appendChild(script);

    function cleanup() {
      document.body.removeChild(document.getElementById('formsite-script'));
    }

    return cleanup;
  });

  function handleHide() {
    updateAssigned();
    toggle();
    if (messageId) {
      trackEvent({ messageId, event: 'Form closed' });
    }
  }

  return (
    <Modal show={isShowing} fullscreen="md-down" size="lg" onHide={handleHide}>
      <Modal.Header closeButton />
      <Modal.Body>
        <FormSiteEmbed formId={embedParams.id} />
      </Modal.Body>
    </Modal>
  );
}

FormSiteModal.propTypes = {
  isShowing: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  updateAssigned: PropTypes.func,
  embedParams: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
    prePopulate: PropTypes.objectOf(PropTypes.string),
  }).isRequired,
  messageId: PropTypes.string,
};

FormSiteModal.defaultProps = {
  isShowing: true,
  updateAssigned: () => '',
  messageId: null,
};

function FormSiteEmbed({ formId }) {
  // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid
  return <a name={`form${formId}`} id={`formAnchor${formId}`} />;
}

FormSiteEmbed.propTypes = {
  formId: PropTypes.string.isRequired,
};
